var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsorted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1283 9.26995C11.2132 9.35477 11.2556 9.45522 11.2556 9.57129C11.2556 9.68736 11.2132 9.78781 11.1283 9.87263L8.12835 12.8726C8.04353 12.9574 7.94308 12.9999 7.82701 12.9999C7.71094 12.9999 7.61049 12.9574 7.52567 12.8726L4.52567 9.87263C4.44085 9.78781 4.39844 9.68736 4.39844 9.57129C4.39844 9.45522 4.44085 9.35477 4.52567 9.26995C4.61049 9.18513 4.71094 9.14272 4.82701 9.14272H10.827C10.9431 9.14272 11.0435 9.18513 11.1283 9.26995ZM11.1283 6.69852C11.2132 6.78334 11.2556 6.88379 11.2556 6.99986C11.2556 7.11593 11.2132 7.21638 11.1283 7.3012C11.0435 7.38602 10.9431 7.42843 10.827 7.42843H4.82701C4.71094 7.42843 4.61049 7.38602 4.52567 7.3012C4.44085 7.21638 4.39844 7.11593 4.39844 6.99986C4.39844 6.88379 4.44085 6.78334 4.52567 6.69852L7.52567 3.69852C7.61049 3.6137 7.71094 3.57129 7.82701 3.57129C7.94308 3.57129 8.04353 3.6137 8.12835 3.69852L11.1283 6.69852Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsorted);
export default __webpack_public_path__ + "static/media/unsorted.8660ee762c964fb362b309053169765d.svg";
export { ForwardRef as ReactComponent };